// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","communityRating":"_2A8MqE0x87kvCjHGySiuBg","naText":"o9DFUjIkMhr45Dd7_gtyV"};